import SiteMessage, { SiteMessageButton } from "./SiteMessage";

function PublishedTemplateNotFound() {
  return (
    <SiteMessage
      title="This Marketplace is disabled at this moment, please try again later!"
      subtitle="Or if you are building the marketplace, click below to Sign In."
    >
      <SiteMessageButton
        href={process.env.NEXT_PUBLIC_MANAGER_APP_URL}
        variant="contained"
      >
        Sign In
      </SiteMessageButton>
    </SiteMessage>
  );
}

export default PublishedTemplateNotFound;
